export default class ServiceKey {
  serviceCode?: string;

  serviceTypeCode?: string;
}
